<style lang="less">
.login-vue {
  position: absolute;
  inset: 0;
  overflow: hidden;
  background:
    radial-gradient(900px 480px at 88% 18%, rgba(55, 136, 238, 0.14), transparent 58%),
    radial-gradient(700px 420px at 8% 88%, rgba(45, 123, 244, 0.08), transparent 55%),
    #f0f2f5;
  font-family: "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif;
}

.login-wrap {
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 56px;
  padding: 40px 48px;
  box-sizing: border-box;
}

.login-stage {
  width: min(46vw, 520px);
  flex-shrink: 1;
  pointer-events: none;
}

.login-stage svg {
  width: 100%;
  height: auto;
  display: block;
  filter: drop-shadow(0 24px 36px rgba(55, 136, 238, 0.18));
}

.login-card {
  width: 420px;
  flex-shrink: 0;
  max-width: calc(100% - 32px);
  background: #fff;
  border-radius: 28px;
  padding: 40px 40px 36px;
  box-shadow:
    0 20px 48px rgba(24, 80, 160, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.04);
}

.login-card-head {
  display: flex;
  align-items: center;
  margin-bottom: 28px;
}

.login-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 700;
  color: #111;
  letter-spacing: -0.02em;
}

.login-logo-dots {
  display: flex;
  gap: 4px;
}

.login-logo-dots i {
  width: 12px;
  height: 12px;
  border-radius: 3px;
  display: block;

  &:nth-child(1) { background: #9ec9ff; }
  &:nth-child(2) { background: #3788ee; }
  &:nth-child(3) { background: #2d7bf4; }
}

.login-card h1 {
  margin: 0 0 28px;
  font-size: 40px;
  line-height: 1.1;
  font-weight: 700;
  color: #111;
  letter-spacing: -0.03em;
}

.login-field {
  margin-bottom: 18px;
}

.login-field-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 8px;
}

.login-field label {
  display: block;
  font-size: 13px;
  color: #8b93a7;
  margin-bottom: 8px;
}

.login-field-row label {
  margin-bottom: 0;
}

.login-field input {
  width: 100%;
  height: 48px;
  padding: 0 16px;
  border: 1.5px solid #e6edf5;
  border-radius: 14px;
  background: #f7f9fc;
  font-size: 14px;
  color: #1a1a1a;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;

  &::placeholder {
    color: #c5cad6;
  }

  &:focus {
    border-color: #3788ee;
    background: #fff;
    box-shadow: 0 0 0 4px rgba(55, 136, 238, 0.14);
  }
}

.login-submit {
  margin-top: 10px;
  width: 100%;
  height: 50px;
  border: 0;
  border-radius: 16px;
  background: #3788ee;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.15s ease, background 0.15s ease;

  &:hover {
    background: #2d7bf4;
  }

  &:active {
    transform: translateY(1px);
  }

  &[disabled] {
    opacity: 0.65;
    cursor: default;
  }
}

.login-icp {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 16px;
  z-index: 3;
  text-align: center;
  font-size: 12px;
  line-height: 1.6;
  color: #8b93a7;

  a {
    color: inherit;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }
}

@media (max-width: 960px) {
  .login-wrap {
    flex-direction: column;
    gap: 28px;
    padding: 28px 16px 56px;
  }

  .login-stage {
    order: -1;
    width: min(78vw, 360px);
  }
}
</style>

<template>
  <div class="login-vue">
    <div class="login-wrap">
      <div class="login-card">
        <div class="login-card-head">
          <div class="login-logo">
            <span class="login-logo-dots"><i></i><i></i><i></i></span>
          </div>
        </div>
        <h1>登录</h1>
        <div class="login-field">
          <label>用户名</label>
          <input
            type="text"
            name="username"
            v-model="login.username"
            autocomplete="off"
            placeholder="请输入用户名"
          />
        </div>
        <div class="login-field">
          <div class="login-field-row">
            <label>密码</label>
          </div>
          <input
            type="password"
            name="password"
            v-model="login.password"
            autocomplete="off"
            placeholder="请输入密码"
            @keyup.enter="submit"
          />
        </div>
        <button class="login-submit" type="button" :disabled="loading" @click="submit">
          {{ loading ? '登录中…' : '登录' }}
        </button>
      </div>

      <div class="login-stage" aria-hidden="true">
        <svg viewBox="0 0 640 520" fill="none">
          <ellipse cx="330" cy="430" rx="210" ry="28" fill="#c5d8f2" opacity="0.7"/>
          <path d="M140 250c0-8 18-14 48-18 86-12 230-12 316 0 30 4 48 10 48 18v78c0 22-70 40-206 40S140 350 140 328V250z" fill="#2d7bf4"/>
          <path d="M140 248c0 16 70 30 206 30s206-14 206-30c0-16-70-30-206-30S140 232 140 248z" fill="#5aa2ff"/>
          <rect x="118" y="168" width="46" height="46" rx="10" fill="#7eb6ff" transform="rotate(-18 141 191)"/>
          <rect x="472" y="196" width="38" height="38" rx="8" fill="#b9d7ff" transform="rotate(16 491 215)"/>
          <rect x="508" y="132" width="22" height="22" rx="6" fill="#fff"/>
          <rect x="168" y="112" width="16" height="16" rx="4" fill="#fff" opacity="0.9"/>
          <ellipse cx="248" cy="318" rx="78" ry="26" fill="#1d5fc4" opacity="0.28"/>
          <path d="M198 250c-4-54 28-102 78-108 52-6 92 34 96 86 2 28-8 48-18 58 10 8 16 22 12 36-6 18-28 22-42 10-8 16-28 22-46 16-22-8-32-28-28-48-22 6-50-8-52-50z" fill="#fff7c9"/>
          <circle cx="246" cy="232" r="7" fill="#2b2438"/>
          <circle cx="286" cy="228" r="7" fill="#2b2438"/>
          <path d="M248 252c10 8 28 8 38-2" stroke="#2b2438" stroke-width="3" stroke-linecap="round"/>
          <path d="M188 168c18-22 8-40-6-46 22 2 38 20 28 48" fill="#fff7c9"/>
          <path d="M318 164c-8-24 8-40 24-42-4 22 2 38-24 42z" fill="#fff7c9"/>
          <ellipse cx="400" cy="300" rx="54" ry="18" fill="#1d5fc4" opacity="0.28"/>
          <path d="M352 168c-2 0-8 8-10 28-2 22 6 78 18 112 6 16 18 22 32 18 20-6 48-8 62 4 8-38 10-88-6-124-12-28-38-42-62-42-14 0-32 4-34 4z" fill="#f4f6fb"/>
          <circle cx="392" cy="214" r="7" fill="#2b2438"/>
          <circle cx="424" cy="214" r="7" fill="#2b2438"/>
          <path d="M396 236c10 8 24 8 34 0" stroke="#2b2438" stroke-width="3" stroke-linecap="round"/>
          <circle cx="378" cy="148" r="10" fill="#f4f6fb"/>
          <circle cx="438" cy="150" r="10" fill="#f4f6fb"/>
          <rect x="430" y="96" width="28" height="28" rx="7" fill="#9ec9ff" transform="rotate(20 444 110)"/>
        </svg>
      </div>
    </div>
    <div class="login-icp">
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">闽ICP备18015643号</a>
    </div>
  </div>
</template>
<script>
import Login from '@model/login/Login';
import Request from '@common/request';
import utils from '@common/utils';
import { endLogout } from '@common/ajax';
import { message } from 'heyui';

export default {
  data() {
    return {
      login: Login.parse({}),
      loading: false
    };
  },
  mounted() {
    endLogout();
    this.loading = false;
  },
  methods: {
    submit() {
      const username = String(this.login.username || '').trim();
      const password = String(this.login.password || '');
      if (!username) {
        message.error('请输入用户名');
        return;
      }
      if (!password) {
        message.error('请输入密码');
        return;
      }
      if (this.loading) return;
      this.loading = true;
      Request.Login.login({ username, password }).then(resp => {
        if (resp.ok) {
          const msg = resp.body || {};
          utils.saveLocal('token', msg.value);
          utils.saveLocal('username', msg.username || username);
          window.location.replace('/settlement-process');
          return;
        }
        message.error(resp._msg || resp.msg || '用户名或密码错误');
        this.loading = false;
      }).catch(() => {
        message.error('登录失败，请检查后端服务');
        this.loading = false;
      });
    }
  }
};
</script>
